import {saraTheme} from "../../theme/saraTheme";

const yup = require("yup");
export const logisticsMap = [
  {
    id: 'partecipazioneRoma',
    name: "partecipazioneRoma",
    title: 'Roma',
    subtitle: "",
    fields: [
      {
        id: 'agendaRoma',
        name: "agendaRoma",
        type: 'agenda',
        conditions: {
          type: "and",
          predicates: [
            {
              id: 'romaPartecipazioneConferma',
              value: 'si'
            }
          ]
        },
        cols: {
          xs: 12,
          md: 12
        }
      },
      {
        id: 'parcheggioRoma',
        name: "parcheggioRoma",
        type: 'parcheggio',
        conditions: {
          type: "and",
          predicates: [
            {
              id: 'romaPartecipazioneConferma',
              value: 'si'
            },
            {
              id: 'parcheggioRoma',
              value: 'si'
            }
          ]
        },
        cols: {
          xs: 12,
          md: 12
        }
      },
      /*{
        id: 'navettaAndataRoma',
        name: "navettaAndataRoma",
        type: 'navetta',
        conditions: {
          type: "and",
          predicates: [
            {
              id: 'romaPartecipazioneConferma',
              value: 'si'
            },
            {
              id: 'navettaAndataRoma',
              value: 'navettaSedeViaPo'
            }
          ]
        },
        cols: {
          xs: 12,
          md: 12
        }
      },
      {
        id: 'navettaAndataRoma',
        name: "navettaAndataRoma",
        type: 'navetta',
        conditions: {
          type: "and",
          predicates: [
            {
              id: 'romaPartecipazioneConferma',
              value: 'si'
            },
            {
              id: 'navettaAndataRoma',
              value: 'navettaStazioneTermini1'
            }
          ]
        },
        cols: {
          xs: 12,
          md: 12
        }
      },
      {
        id: 'navettaAndataRoma',
        name: "navettaAndataRoma",
        type: 'navetta',
        conditions: {
          type: "and",
          predicates: [
            {
              id: 'romaPartecipazioneConferma',
              value: 'si'
            },
            {
              id: 'navettaAndataRoma',
              value: 'navettaStazioneTermini2'
            }
          ]
        },
        cols: {
          xs: 12,
          md: 12
        }
      },
      {
        id: 'navettaAndataRoma',
        name: "navettaAndataRoma",
        type: 'navetta',
        conditions: {
          type: "and",
          predicates: [
            {
              id: 'romaPartecipazioneConferma',
              value: 'si'
            },
            {
              id: 'navettaAndataRoma',
              value: 'navettaAeroportoFiumicino1'
            }
          ]
        },
        cols: {
          xs: 12,
          md: 12
        }
      },
      {
        id: 'navettaAndataRoma',
        name: "navettaAndataRoma",
        type: 'navetta',
        conditions: {
          type: "and",
          predicates: [
            {
              id: 'romaPartecipazioneConferma',
              value: 'si'
            },
            {
              id: 'navettaAndataRoma',
              value: 'navettaAeroportoFiumicino2'
            }
          ]
        },
        cols: {
          xs: 12,
          md: 12
        }
      },*/
      /** RITORNO */
      /*{
        id: 'navettaRitornoRoma',
        name: "navettaRitornoRoma",
        type: 'navetta',
        conditions: {
          type: "and",
          predicates: [
            {
              id: 'romaPartecipazioneConferma',
              value: 'si'
            },
            {
              id: 'navettaRitornoRoma',
              value: 'navettaSedeViaPo'
            }
          ]
        },
        cols: {
          xs: 12,
          md: 12
        }
      },
      {
        id: 'navettaRitornoRoma',
        name: "navettaRitornoRoma",
        type: 'navetta',
        conditions: {
          type: "and",
          predicates: [
            {
              id: 'romaPartecipazioneConferma',
              value: 'si'
            },
            {
              id: 'navettaRitornoRoma',
              value: 'navettaStazioneTermini1'
            }
          ]
        },
        cols: {
          xs: 12,
          md: 12
        }
      },
      {
        id: 'navettaRitornoRoma',
        name: "navettaRitornoRoma",
        type: 'navetta',
        conditions: {
          type: "and",
          predicates: [
            {
              id: 'romaPartecipazioneConferma',
              value: 'si'
            },
            {
              id: 'navettaRitornoRoma',
              value: 'navettaStazioneTermini2'
            }
          ]
        },
        cols: {
          xs: 12,
          md: 12
        }
      },
      {
        id: 'navettaRitornoRoma',
        name: "navettaRitornoRoma",
        type: 'navetta',
        conditions: {
          type: "and",
          predicates: [
            {
              id: 'romaPartecipazioneConferma',
              value: 'si'
            },
            {
              id: 'navettaRitornoRoma',
              value: 'navettaAeroportoFiumicino1'
            }
          ]
        },
        cols: {
          xs: 12,
          md: 12
        }
      },
      {
        id: 'navettaRitornoRoma',
        name: "navettaRitornoRoma",
        type: 'navetta',
        conditions: {
          type: "and",
          predicates: [
            {
              id: 'romaPartecipazioneConferma',
              value: 'si'
            },
            {
              id: 'navettaRitornoRoma',
              value: 'navettaAeroportoFiumicino2'
            }
          ]
        },
        cols: {
          xs: 12,
          md: 12
        }
      },*/
    ],
    conditions: {
      type: "and",
      predicates: [
        {
          id: 'romaPartecipazioneConferma',
          value: 'si'
        }
      ]
    },
  },
  {
    id: 'partecipazioneMilano',
    name: "partecipazioneMilano",
    title: 'Milano',
    subtitle: "",
    fields: [
      {
        id: 'agendaMilano',
        name: "agendaMilano",
        type: 'agenda',
        conditions: {
          type: "and",
          predicates: [
            {
              id: 'milanoPartecipazioneConferma',
              value: 'si'
            }
          ]
        },
        cols: {
          xs: 12,
          md: 12
        }
      },
      {
        id: 'parcheggioMilano',
        name: "parcheggioMilano",
        type: 'parcheggio',
        conditions: {
          type: "and",
          predicates: [
            {
              id: 'milanoPartecipazioneConferma',
              value: 'si'
            },
            {
              id: 'parcheggioMilano',
              value: 'si'
            }
          ]
        },
        cols: {
          xs: 12,
          md: 12
        }
      },
      /*{
        id: 'navettaAndataMilano',
        name: "navettaAndataMilano",
        type: 'navetta',
        conditions: {
          type: "and",
          predicates: [
            {
              id: 'milanoPartecipazioneConferma',
              value: 'si'
            },
            {
              id: 'navettaAndataMilano',
              value: 'navettaStazioneMilanoCentrale'
            }
          ]
        },
        cols: {
          xs: 12,
          md: 12
        }
      },
      {
        id: 'navettaRitornoMilano',
        name: "navettaRitornoMilano",
        type: 'navetta',
        conditions: {
          type: "and",
          predicates: [
            {
              id: 'milanoPartecipazioneConferma',
              value: 'si'
            },
            {
              id: 'navettaRitornoMilano',
              value: 'navettaStazioneMilanoCentrale'
            }
          ]
        },
        cols: {
          xs: 12,
          md: 12
        }
      },*/
    ],
    conditions: {
      type: "and",
      predicates: [
        {
          id: 'milanoPartecipazioneConferma',
          value: 'si'
        }
      ]
    },
  },
]
